// URL prefix constants for organization and program IDs
export const URL_PREFIXES = {
  ORGANIZATION: 'org-',
  PROGRAM: 'prog-',
} as const;
